import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../news';
function fetchNews(languageId) {
    var _a;
    return _a = {
            type: ActionTypes.GET_NEWS
        },
        _a[CALL_API] = {
            endpoint: "/get-news?languageId=".concat(languageId),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_GET_NEWS,
                ActionTypes.FAILURE_GET_NEWS
            ]
        },
        _a;
}
export function getNews(languageId) {
    return function (dispatch) {
        return dispatch(fetchNews(languageId));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/news.js